import { CUSTOM_ELEMENTS_SCHEMA, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

import { Observable } from 'rxjs';
import { SdCheckboxGroupModelDirective } from 'src/app/common/directives/sd-checkbox-group-model.directive';
import { SdCheckBoxValueInjectorDirective } from 'src/app/common/directives/sd-checkbox-value-injector.directive';
import { SdModelDirective } from 'src/app/common/directives/sd-model.directive';
import { FilterType } from 'src/openapi-client';
import { FondsFilterBlockData, FondsFilterSelections } from '../fonds-filters/fonds-filters';
import { FondsFilterBlockGridPipe } from './fonds-filter-block-grid.pipe';
import { GetArraySelectionValuePipe } from './get-array-selection-value.pipe';

@Component({
  selector: '[wct-fonds-filter-block]',
  standalone: true,
  imports: [
    FondsFilterBlockGridPipe,
    SdModelDirective,
    SdCheckboxGroupModelDirective,
    SdCheckBoxValueInjectorDirective,
    GetArraySelectionValuePipe
  ],
  templateUrl: './fonds-filter-block.component.html',
  styleUrl: './fonds-filter-block.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FondsFilterBlockComponent implements OnDestroy {
  @Input({ required: true }) public data: FondsFilterBlockData;
  @Input({ required: true }) public selection: FondsFilterSelections;
  @Input({ required: true }) public update$: Observable<void>;

  @Output() dirty = new EventEmitter<void>();

  protected readonly FilterType = FilterType;

  ngOnDestroy(): void {
    this.dirty.complete();
  }
}
